
import { defineComponent, reactive } from 'vue';

type State = {
  dialog: boolean;
  resolve: Function;
  reject: Function;
  message?: string;
  errorMessage?: string;
  title: string;
  options: {};
};

export default defineComponent({
  name: 'DialogConfirm',

  setup() {
    const state = reactive<State>({
      dialog: false,
      resolve: () => {
        console.log('resolve');
      },
      reject: () => {
        console.log('reject');
      },
      message: '',
      errorMessage: '',
      title: '',
      options: {
        color: 'primary',
        okBtnColor: 'primary',
        width: 290,
        zIndex: 200,
        hideCancel: false,
      },
    });

    const open = (title: string, message?: string, options: object = {}, errorMessage?: string) => {
      state.dialog = true;
      state.title = title;
      state.message = message;
      state.errorMessage = errorMessage;
      state.options = Object.assign(state.options, options);
      return new Promise((resolve, reject) => {
        state.resolve = resolve;
        state.reject = reject;
      });
    };

    const ok = () => {
      state.resolve(true);
      state.dialog = false;
    };
    const cancel = () => {
      state.resolve(false);
      state.dialog = false;
    };

    return {
      state,
      open,
      ok,
      cancel,
    };
  },
});
